import {
    FETCH_AGENTS_REQUEST,
    FETCH_AGENTS_SUCCESS,
    FETCH_AGENTS_FAILURE,

    UPDATE_AGENT_STATUS_REQUEST,
    UPDATE_AGENT_STATUS_SUCCESS,
    UPDATE_AGENT_STATUS_FAILURE,
} from "../actions/types";


const initialState = {

    agents: {
        data: [],
    },

    loading: false,

    error: null,

    message: "",

    page: 1,

    hasMore: true,

    total: 0,
};


export default function agentReducer(
    state = initialState,
    action
) {

    switch (action.type) {


        case FETCH_AGENTS_REQUEST:

        case UPDATE_AGENT_STATUS_REQUEST:

            return {
                ...state,

                loading: true,

                error: null,
            };


        case FETCH_AGENTS_SUCCESS: {

            const {
                data,
                page,
                pages,
                total,
            } = action.payload || {};

            return {
                ...state,

                loading: false,

                agents: {
                    data: data || [],
                },

                page:
                    page || 1,

                hasMore:
                    page < pages,

                total:
                    total || 0,

                message:
                    "Agents loaded successfully",
            };
        }


        case UPDATE_AGENT_STATUS_SUCCESS: {

            const updatedAgent =
                action.payload;

            return {
                ...state,

                loading: false,

                agents: {

                    ...state.agents,

                    data:
                        Array.isArray(
                            state.agents?.data
                        )
                            ? state.agents.data.map(
                                (agent) =>
                                    agent.agent_id ===
                                    updatedAgent.agent_id
                                        ? {
                                            ...agent,
                                            ...updatedAgent,
                                        }
                                        : agent
                            )
                            : [],
                },

                message:
                    "Agent status updated successfully",
            };
        }


        case FETCH_AGENTS_FAILURE:

        case UPDATE_AGENT_STATUS_FAILURE:

            return {
                ...state,

                loading: false,

                error:
                    action.payload,
            };


        default:

            return state;
    }
}